import React from "react";
export function generateItemsQRCodeValue(
  selectionItemAmounts,
  WarehouseID = -1,
  ClientID = -1
) {
  if (selectionItemAmounts.size === 0) {
    return "";
  }
  console.log("Selection item amopunts in qr code gen", selectionItemAmounts);

  let itemsWithAmounts = "";

  const itemsArray = Array.from(selectionItemAmounts).map(([key, value]) => {
    return { id: key, amount: value };
  });

  Array.from(selectionItemAmounts).forEach(([key, value]) => {
    itemsWithAmounts += key + "," + value + ",";
  });

  if (itemsWithAmounts.length === 0) {
    return "";
  }
  const qrData =
    new Date().toISOString() +
    ";" +
    (WarehouseID !== -1 ? WarehouseID : "-1") +
    ";" +
    (ClientID !== -1 ? ClientID : "-1") +
    ";" +
    itemsArray.length +
    ";" +
    itemsArray.reduce((sum, item) => sum + item.amount, 0) +
    ";" +
    itemsWithAmounts;

  return JSON.stringify(qrData);
}

export function parseItemsCodeToMap(code) {
  if (!code || code.length === 0) {
    return new Map();
  }

  try {
    const parts = code.split(";");
    if (parts.length < 6) {
      throw new Error("Invalid QR code format");
    }

    const itemsWithAmounts = parts[5].split(",");
    const itemMap = new Map();

    for (let i = 0; i < itemsWithAmounts.length - 1; i += 2) {
      const id = itemsWithAmounts[i];
      const amount = parseInt(itemsWithAmounts[i + 1], 10);
      itemMap.set(id, amount);
    }

    return itemMap;
  } catch (error) {
    console.error("Error parsing QR code:", error);
    return new Map();
  }
}
